import MemriseApi from '../MemriseApi';
import { TopicsRequest, TopicsResponse } from './schema';

export default class Topics extends MemriseApi {
  constructor() {
    super({ endpointPrefix: '/topics' });
  }

  public async getTopics(params?: TopicsRequest): Promise<TopicsResponse> {
    return await this.get('/', params);
  }
}

export const TopicsApi = new Topics();
